import { InfoOutlined } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { usePopups } from 'contexts/Popups/Popups';

export default function Info({ popupName }: InfoProps) {

    const popups = usePopups();

    const popup = popups.get(popupName);

    if (!popup) {
        console.warn(`[Info] Popup '${popupName}' not found`)
        return null;
    }

    return <Box color="grey.800">
        <IconButton aria-label={popup?.label} color="inherit" onClick={() => popups.show(popupName)}>
            <InfoOutlined />
        </IconButton>
    </Box>;

}